module.exports = __webpack_public_path__ + "amcharts/images/dragIconRectBigBlackH.svg";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/dragIconRectBigBlackH.svg
// module id = 235
// module chunks = 0